<template>
    <div class="yate-screen">
        <div class="content">
            <ConversationSidebarComponent 
                :email="email" 
                :conversation_id="null"
                :is_new_conversation="false"
                :conversation_title="''"
                :new_conversation_info="{}"
                :isSidebarMenuOpen="isSidebarMenuOpen"
                :subscription="subscription"
                :modoRedaccion="false"
                :userProfilePicture="profilePicture"
                :userName="name"
                :permissions="permissions"
                @show-toast="showToast"
                @logout="logout"
                @conversation-selected="handleConversationSelected" />

            <div class="main-display">
                <HeaderMenuComponent 
                    title="Ya pagué mi suscripción"
                    :permissions="permissions" 
                    :subscription="subscription"
                    :isMobile="isMobile"
                    :showSubscribeButton="false"
                    @toggle-sidebar="toggleSidebar"
                    @logout="logout"
                    @show-toast="showToast" />

                <div class="content-area">
                    <div class="subscription-content">
                        <div class="thanks-section">
                            <h1>¡Muchas gracias!</h1>
                            <p>🧑🏽‍🤝‍🧑🏽 ChatPTS es un esfuerzo colectivo y militante del PTS y La Izquierda Diario</p>
                            <p>🫂 Solo puede gestionarse con personas como vos</p>
                            <p>💲 No recibimos financiación de ningún tipo</p>
                        </div>
                        
                        <div class="subscription-form-section">
                            <h2>Vincular pago existente</h2>
                            <p>👉🏽 Si ya hiciste el pago a tu suscripción mensual a través de MercadoPago y aún no está asociado a
                                tu usuario, por favor, completá tus datos abajo.</p>
                            
                            <div class="form">
                                <label for="email">Ingresá el mail de la cuenta de MercadoPago que usaste, o el mail que pusiste al
                                    momento del pago en MercadoPago y el número de comprobante de pago. Podés encontrarlo como "número de
                                    operación" en el comprobante.</label>
                                
                                <div class="inputs">
                                    <input type="email" id="email" v-model="mercadopago_email" @keyup.enter="buscarSuscripcion"
                                        placeholder="Email de MercadoPago" />
                                    <input type="text" id="transaction_id" v-model="transaction_id"
                                        placeholder="ID de la transacción de MercadoPago" />
                                </div>
                                
                                <button @click="buscarSuscripcion" class="search-button">BUSCAR SUSCRIPCIÓN</button>
                            </div>
                            
                            <p class="contact-info">En caso de que continúes con algún problema, por favor,&nbsp;
                                <a href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit" 
                                   target="_blank">contactanos</a>
                            </p>
                        </div>
                        
                        <div class="divider">- ó -</div>
                        
                        <div class="new-payment-section">
                            <RouterLink to="/suscribirse">
                                <button class="donate-button">Hacer otro aporte</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Toast notification -->
        <div v-if="toast.show" class="toast" :class="toast.type">
            {{ toast.message }}
        </div>
    </div>
</template>

<script>
import ConversationSidebarComponent from '@/components/ConversationSidebarComponent.vue';
import HeaderMenuComponent from '@/components/HeaderMenuComponent.vue';
import axios from 'axios';

axios.defaults.withCredentials = true;

export default {
    name: "YateScreen",
    components: {
        ConversationSidebarComponent,
        HeaderMenuComponent
    },
    data() {
        return {
            mercadopago_email: '',
            email: '',
            name: '',
            permissions: [],
            profilePicture: '',
            isSidebarMenuOpen: false,
            subscription: {},
            transaction_id: '',
            toast: {
                show: false,
                message: '',
                type: 'info',
                timeout: null
            },
            isMobile: false
        };
    },
    mounted() {
        this.getUserData(false);
        
        // Check if device is mobile
        this.checkMobile();

        // Add resize event listener
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        // Remove resize event listener
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        async buscarSuscripcion() {
            try {
                const response = await axios.post(process.env.VUE_APP_BASE_URL + '/api/v2/suscripciones/buscar-suscripcion/', {
                    mercadopago_email: this.mercadopago_email,
                    transaction_id: this.transaction_id,
                });
                if (response.status === 200) {
                    this.showToast('Suscripción encontrada', 'success');
                    this.$router.push({ name: 'main-view' });
                }
            } catch (error) {
                console.error(error);
                const detail = error.response ? error.response.data.detail : 'Error desconocido';
                this.showToast('¡Estamos con mucha demanda! al intentar buscar la suscripción: ' + detail, 'error');
            }
        },
        
        async getUserData(withToast = true) {
            try {
                const response = await axios.get(process.env.VUE_APP_BASE_URL + '/api/v2/users/me/');
                const { email, name, permissions, picture, subscription } = response.data;
                
                this.email = email;
                this.name = name;
                this.permissions = permissions;
                this.profilePicture = picture;
                this.subscription = subscription;

                if (!subscription || !subscription.valid_until || new Date(subscription.valid_until) < new Date()) {
                    console.log("Suscribite :)");
                } else {
                    this.$router.push({ name: 'main-view' });
                }
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    this.$router.push({ name: 'main-view' });
                } else {
                    console.error('Error during user data request:', err);
                    if (withToast) {
                        const detail = err.response ? err.response.data.detail : err.message;
                        this.showToast('Error al obtener tus datos. Por favor, intentá de nuevo. Código de error: "' + detail + '"', 'error');
                    }
                }
            }
        },

        showToast(message, type = 'info') {
            // Clear any existing timeout
            if (this.toast.timeout) {
                clearTimeout(this.toast.timeout);
            }

            // Show the toast
            this.toast.show = true;
            this.toast.message = message;
            this.toast.type = type;

            // Set a timeout to hide the toast
            this.toast.timeout = setTimeout(() => {
                this.toast.show = false;
            }, 3000);
        },

        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },

        toggleSidebar() {
            this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
        },

        handleConversationSelected(conversationId) {
            // Navigate to main chat view with the selected conversation
            this.$router.push({ 
                name: 'main-view',
                query: { conversation_id: conversationId }
            });
        },

        logout() {
            axios.post(process.env.VUE_APP_BASE_URL + '/api/auth/logout/')
                .then(() => {
                    this.email = '';
                    this.name = '';
                    this.permissions = [];
                    this.profilePicture = '';
                    this.subscription = {};
                    console.log('Logged out');
                    this.showToast('Sesión cerrada. ¡Hasta la próxima!', 'success');
                    setTimeout(() => {
                        this.$router.push({ name: 'main-view' });
                    }, 2000);
                })
                .catch((error) => {
                    console.error('Error logging out:', error);
                    this.showToast('¡Estamos con mucha demanda! al intentar cerrar sesión.', 'error');
                    
                    // Clear local variables even on error for security
                    this.email = '';
                    this.name = '';
                    this.permissions = [];
                    this.profilePicture = '';
                    this.subscription = {};
                });
        }
    }
};
</script>

<style scoped>
.yate-screen {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f5f5f5;
    color: #333333;
    width: 100%;
    position: relative;
}

.content {
    display: flex;
    flex: 1;
    overflow: hidden;
    position: relative;
}

.main-display {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #f5f5f5;
}

.content-area {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.subscription-content {
    max-width: 800px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.thanks-section {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.thanks-section h1 {
    color: #a1344e;
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 24px;
}

.thanks-section p {
    font-size: 18px;
    margin-bottom: 16px;
    line-height: 1.6;
}

.subscription-form-section {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.subscription-form-section h2 {
    color: #a1344e;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
}

.subscription-form-section > p {
    font-size: 16px;
    margin-bottom: 24px;
    line-height: 1.6;
}

.form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form label {
    font-size: 14px;
    color: #666666;
    line-height: 1.5;
}

.inputs {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.inputs input {
    padding: 12px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s;
}

.inputs input:focus {
    outline: none;
    border-color: #a1344e;
}

.search-button {
    background-color: #a1344e;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    text-transform: uppercase;
}

.search-button:hover {
    background-color: #b71c1c;
}

.contact-info {
    margin-top: 24px;
    font-size: 14px;
    text-align: center;
    color: #666666;
}

.contact-info a {
    color: #a1344e;
    text-decoration: none;
}

.contact-info a:hover {
    text-decoration: underline;
}

.divider {
    text-align: center;
    font-size: 18px;
    color: #999999;
    font-weight: 500;
}

.new-payment-section {
    text-align: center;
}

.donate-button {
    background-color: #a1344e;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 16px 32px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    text-decoration: none;
    display: inline-block;
}

.donate-button:hover {
    background-color: #b71c1c;
}

/* Toast notification */
.toast {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    z-index: 1000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    min-width: 250px;
    text-align: center;
}

.toast.info {
    background-color: #2196F3;
}

.toast.success {
    background-color: #4CAF50;
}

.toast.warning {
    background-color: #FF9800;
}

.toast.error {
    background-color: #F44336;
}

@media screen and (max-width: 768px) {
    .content-area {
        padding: 16px;
    }

    .subscription-content {
        gap: 24px;
    }

    .thanks-section,
    .subscription-form-section {
        padding: 24px;
    }

    .thanks-section h1 {
        font-size: 28px;
    }

    .thanks-section p {
        font-size: 16px;
    }

    .subscription-form-section h2 {
        font-size: 20px;
    }

    .form {
        gap: 16px;
    }

    .inputs input {
        font-size: 16px;
    }

    .search-button {
        padding: 12px 20px;
        font-size: 14px;
    }

    .donate-button {
        padding: 14px 28px;
        font-size: 16px;
    }
}
</style>
